<app-header-partial></app-header-partial>
<div class="container">
  <div class="wrapper">
    <h2 class="title">Comment souhaitez-vous postuler ?</h2>
    <div class="file-container">
      <div class="top">
        <div class="btn-container">
          <button class="btn-telecharger">Télécharger votre CV</button
          ><button>je me connecte</button>
        </div>
      </div>
      <div class="bottom">
        <label for="cv-upload">
          <div class="text">
            <span>{{ labelText[0] }}</span>
            <span>{{ labelText[1] }}</span>
          </div>
        </label>
        <input
          type="file"
          id="cv-upload"
          (change)="onFileSelected($event)"
          accept=".pdf,.docx,.txt"
        />
      </div>
    </div>
    <button class="btn-suivant">Suivant</button>
  </div>
</div>
